export default {
    installation: "Assemblage Video's",
    videos: {

    }
}
